import { render, staticRenderFns } from "./layout-global-menu-column.vue?vue&type=template&id=1850a7fa&scoped=true&"
import script from "./layout-global-menu-column.vue?vue&type=script&lang=js&"
export * from "./layout-global-menu-column.vue?vue&type=script&lang=js&"
import style0 from "./layout-global-menu-column.vue?vue&type=style&index=0&id=1850a7fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850a7fa",
  null
  
)

export default component.exports